import AppContainer from "../Structure/AppContainer";
import React, { useContext, useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import AuthContext from "../../Context/AuthContext";
import useStateCallback from "../../util/customHooks/useStateCallback";
import UpdateStationModal from "./UpdateStationModal";
import ajaxFuelPumps from "../../util/remote/ajaxFuelPumps";
import RegisterFuelPumpModal from "./RegisterFuelPumpModal";
const ViewFuelPumps = () => {
  var station_idd = Number(window.localStorage.getItem("FuelFy@station_id"));

  const { userId } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [pumps, setPumps] = useState([]);
  const [viewType, setViewType] = useState("table view");
  const [station_id, setstation_id] = useState(station_idd); // default
  const fetchPumps = async () => {
    setLoading(true);
    const data = { station_id };
    const response = await ajaxFuelPumps.list_Pumps(data);
    if (response.status === "OK") {
      setPumps(response.details || []);
    } else {
      toast.error(response.message);
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchPumps();
  }, [station_id]);
  const toggleView = (type) => setViewType(type);
  const [update, setUpdate] = useStateCallback(false);
  const handleViewDetails = (pump) => {
    setUpdate(false, () =>
      setUpdate(<UpdateStationModal data={pump} func={fetchPumps} />)
    );
  };
  const [register, setRegister] = useStateCallback(false);
  const handleRegister = () => {
    setRegister(false, () =>
      setRegister(<RegisterFuelPumpModal func={fetchPumps} />)
    );
  };
  const filteredActions = [
    {
      label: "card view",
      icon: "fa-regular fa-address-card",
      className: "btn btn-success btn-sm",
      onClick: () => toggleView("card view"),
    },
    {
      label: "table view",
      icon: "fa-solid fa-table",
      className: "btn btn-success btn-sm",
      onClick: () => toggleView("table view"),
    },
    {
      label: "Register Pump",
      icon: "fa-solid fa-file-pen",
      className: "btn btn-info btn-sm",
      onClick: () => handleRegister(),
    },
  ].filter((action) => action.label !== viewType);
  return (
    <AppContainer
      title="Fuel Pumps"
      previousPageTitle="Dashboard"
      actions={filteredActions}
    >
      <div className="container-fluid">
        <Toaster />
        {update}
        {register}
        {loading ? (
          <div className="text-center my-5 fs-5 text-muted">
            Loading Fuel Pumps...
          </div>
        ) : pumps.length === 0 ? (
          <div className="text-center my-5 fs-5 text-muted">
            No Fuel Pumps Available
          </div>
        ) : viewType === "table view" ? (
          <div className="row">
            <div className="col-12">
              <div className="card custom-card">
                <div className="card-body">
                  <h6 className="card-title mb-1">Fuel Pumps</h6>
                  <p className="text-muted card-sub-title">
                    List of registered fuel pumps
                  </p>
                  <div className="table-responsive">
                    <table className="table table-bordered text-nowrap mb-0">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Pump Code</th>
                          <th>Status</th>
                          <th>Created At</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {pumps.map((pump, index) => (
                          <tr key={pump.id}>
                            <td>{index + 1}</td>
                            <td>{pump.pump_code}</td>
                            <td>
                              <span
                                className={`badge ${
                                  pump.status === "1"
                                    ? "bg-success"
                                    : "bg-danger"
                                }`}
                              >
                                {pump.status === "1" ? "Active" : "Inactive"}
                              </span>
                            </td>
                            <td>{pump.created_at}</td>
                            <td>
                              <button
                                className="btn btn-sm btn-info"
                                onClick={() => handleViewDetails(pump)}
                              >
                                <i className="fe fe-edit-2"></i>
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="row">
            {pumps.map((pump) => (
              <div className="col-md-4 col-lg-3 mb-3" key={pump.id}>
                <div
                  className="card h-100"
                  style={{
                    borderRadius: "12px",
                    boxShadow: "4px 4px 12px rgba(0,0,0,0.1)",
                  }}
                >
                  <div className="card-body text-center">
                    <h6 className="mb-1">{pump.pump_code}</h6>
                    <small className="d-block text-muted">
                      Created: {pump.created_at}
                    </small>
                    <div className="mt-2">
                      <span
                        className={`badge px-3 py-1 ${
                          pump.status === "1" ? "bg-success" : "bg-danger"
                        }`}
                      >
                        {pump.status === "1" ? "Active" : "Inactive"}
                      </span>
                    </div>
                    <div className="d-flex justify-content-center mt-3">
                      <button
                        className="btn btn-sm btn-outline-primary px-3"
                        onClick={() => handleViewDetails(pump)}
                      >
                        <i className="fe fe-edit-2"></i> Edit
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </AppContainer>
  );
};
export default ViewFuelPumps;
